import { Alert, Snackbar } from "@mui/material";

export const emptyAlert = {
    message: null,
    severity: 'info'
}

const AlertNotification = ({ severity, message, duration = 5000, onClose }) => {
    return <Snackbar
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        open={!!message}
        autoHideDuration={duration}
        onClose={onClose}
        sx={{
            zIndex: 9999
        }}
    >
        <Alert severity={severity} sx={{ width: '600px' }}>
            {message}
        </Alert>
    </Snackbar>
}

export default AlertNotification;